import { setClientsSuccessful,setClientsFailed} from "./reducer";
import axios from "axios";
import axiosInstance from "src/common/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getClients:any = (agency_id: any, history: any, page: number = 1, perPage: number = 12, search: string = '', onlyEnabled: boolean = false) => async (dispatch: any) => {
    try {
        let response;
        
        const params: any = {
            agency_id: agency_id,
            page: page,
            per_page: perPage,
            only_enabled: onlyEnabled ? 1 : 0,
        };
        
        if (search && search.trim() !== '') {
            params.search = search.trim();
        }
        
        response = await axiosInstance.get(`/agency-clients`, {
            params: params
        });
        
        const data = await response.data;
        if (data) {
            dispatch(setClientsSuccessful(data));
        }
    } catch (error) {
        dispatch(setClientsFailed(error))
    }
};
